
    export const LISTITEMS: any[] = [
        {"url":"/app", "name":"Page", "icon":"ft-home"},
        {"url":"/login", "name":"Login", "icon":"ft-log-in"},
    ]

